<div class="tw-bg-white tw-rounded-t-6 tw-relative tw-flex tw-flex-col tw-max-h-[70vh]">
  <div class="tw-absolute tw-top-3 tw-right-3 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-z-10"
       (click)="closeBottomSheet()">
    <span class="tw-text-gray-500 tw-text-400 tw-font-bold">&#10005;</span>
  </div>

  <div class="tw-overflow-y-auto tw-flex-1 tw-px-4 tw-pt-6 tw-pb-4 tw-flex tw-flex-col tw-gap-4">
    <div class="tw-flex tw-gap-1 tw-items-start">
      <img src="/assets/icons/water_drop.svg" alt="" class="tw-w-6 tw-h-6 tw-shrink-0 tw-mt-0.5">
      <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-black tw-min-w-0"
            [class.tw-pr-20]="!!data.doctorImage"
            i18n="@@bloodTestAdvised">Blood test advised<br>by your doctor</span>
    </div>

    <div class="tw-bg-orange-25 tw-rounded-4 tw-relative tw-pt-6 tw-px-4 tw-pb-4">
      @if (data.doctorImage) {
        <div class="tw-absolute tw--top-11 tw-right-4 tw-w-16 tw-h-16 tw-rounded-full tw-border-2 tw-border-solid tw-border-orange-25 tw-overflow-hidden tw-z-10">
          <img [src]="data.doctorImage" alt="" class="tw-w-full tw-h-full tw-object-cover">
        </div>
      }

      <p class="tw-font-body tw-font-medium tw-text-200 tw-text-gray-500 tw-mb-3">{{ data.investigationStatus.investigation?.description }}</p>

      <p class="tw-font-body tw-font-medium tw-text-200 tw-text-black tw-mb-1.5" i18n="@@testsRequired">Tests required:</p>
      <div class="tw-flex tw-flex-col tw-gap-1">
        @for (test of normalizedTests; track $index; let i = $index) {
          <div class="tw-bg-white tw-rounded-4 tw-px-2 tw-py-1.5 tw-flex tw-items-center tw-min-h-8">
            <span class="tw-font-body tw-font-bold tw-text-300 tw-text-black">
              {{ i + 1 }}. {{ test.name }}
            </span>
            @if (!test.required) {
              <span class="tw-font-body tw-font-normal tw-text-200 tw-text-gray-400 tw-ml-1 tw-shrink-0" i18n="@@optionalReport">(optional)</span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="tw-px-4 tw-pb-6 tw-pt-2 tw-shrink-0">
    <button class="tw-w-full tw-h-10 tw-bg-teal-600 tw-rounded-2 tw-flex tw-items-center tw-justify-center tw-gap-2"
            (click)="onUploadReport()">
      <span class="tw-font-lexend tw-font-semibold tw-text-400 tw-text-white" i18n="@@uploadReport">Upload report</span>
      <span class="cs-icon-camera tw-text-400 tw-text-white tw-mt-0.5"></span>
    </button>
  </div>
</div>
